import { Vector2d } from "konva/lib/types";
import { IEdgePointersData, IXYNodeShallowData } from "../models/xyflow.models";
import { Position } from "../models/graph-kn.model-enums";
const gapBetweenInOutEdges = 0
export function getEdgeCenter({
  sourceX,
  sourceY,
  targetX,
  targetY,
}: {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
}): [number, number, number, number] {
  const xOffset = Math.abs(targetX - sourceX) / 2;
  const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;

  const yOffset = Math.abs(targetY - sourceY) / 2;
  const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;

  return [centerX, centerY, xOffset, yOffset];
}
export function getNodeConnectPoint(fromNode:IXYNodeShallowData,toNode:IXYNodeShallowData):IEdgePointersData {
  let edgePointersData: IEdgePointersData = {
    pointFrom: {x:0,y:0} , pointFromPosition:Position.Left,
    pointTo: {x:0,y:0} , pointToPosition:Position.Left,
  }
  //fromPoint (source) point position
  if (toNode.y  < fromNode.y  - (Math.abs(fromNode.x - toNode.x) - toNode.widht)) {
  //if (toNode.y  < (fromNode.y - Math.abs(fromNode.x - fromNode.widht)*0.5)) {
    edgePointersData.pointFrom = {
      x:fromNode.x + fromNode.widht/2,
      y:fromNode.y,
    }
    edgePointersData.pointFromPosition = Position.Top
  }
  //else if (toNode.y > fromNode.y ) {
  else if (toNode.y > fromNode.y + (Math.abs(fromNode.x - toNode.x) - toNode.widht)) {
    edgePointersData.pointFrom =  {
      x:fromNode.x + fromNode.widht/2,
      y:fromNode.y + fromNode.height - 5
    }
    edgePointersData.pointFromPosition = Position.Bottom
  }
  else {
    edgePointersData.pointFrom ={
      x:fromNode.x + fromNode.widht,
      y:fromNode.y + fromNode.height/2 ,
    }
    edgePointersData.pointFromPosition = Position.Right
  } 

  //toPoint (target) point position
  let signedGapBetweenInOutEdges = gapBetweenInOutEdges * (toNode.y > fromNode.y? -1 : 1)
  if (toNode.x  > fromNode.x) {
    edgePointersData.pointTo = {
      x:toNode.x ,
      y:toNode.y + toNode.height/2  + signedGapBetweenInOutEdges,
    }
    edgePointersData.pointToPosition = Position.Left
  }
/*   else if (toNode.y > (fromNode.y + fromNode.height + Math.abs(fromNode.x - fromNode.widht)*0.2)) {
    edgePointersData.pointTo =  {
      x:toNode.x + toNode.widht/2 ,
      y:toNode.y + toNode.height - 5
    }
    edgePointersData.pointToPosition = Position.Bottom
  } */
  else {
    edgePointersData.pointTo ={
      x:toNode.x + toNode.widht,
      y:toNode.y + toNode.height/2 + signedGapBetweenInOutEdges,
    }
    edgePointersData.pointToPosition = Position.Right
  } 

  /* if (toNode.y  < (fromNode.y - Math.abs(fromNode.x - fromNode.widht)*0.5)) {
    return {
      pointFrom: {
        x:fromNode.x + fromNode.widht/2 ,
        y:fromNode.y,
      },
      pointFromPosition:Position.Top,
      pointTo: {
        x:toNode.x ,
        y:toNode.y + toNode.height/2,
      },
      pointToPosition:Position.Left,
    }
  }
  if (toNode.y > (fromNode.y + fromNode.height + Math.abs(fromNode.x - fromNode.widht)*0.2)) {
    return {
      pointFrom: {
        x:fromNode.x + fromNode.widht/2 ,
        y:fromNode.y + fromNode.height - 5
      },
      pointFromPosition:Position.Bottom,
      pointTo: {
        x:toNode.x  ,
        y:toNode.y + toNode.height/2
      },
      pointToPosition:Position.Left,
    }
  }
  return {
    pointFrom:{
      x:fromNode.x + fromNode.widht,
      y:fromNode.y + fromNode.height/2,
    },
    pointFromPosition:Position.Right,
    pointTo:{
      x:toNode.x,
      y:toNode.y + toNode.height/2,
    },
    pointToPosition:Position.Left
  } */
  return edgePointersData
}